import { render, staticRenderFns } from "./GameResultTournamentModule.vue?vue&type=template&id=d923e290&"
import script from "./GameResultTournamentModule.vue?vue&type=script&lang=js&"
export * from "./GameResultTournamentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports